import { ExcelService } from 'src/app/services/Excel.service';
import { ClientsService } from './../../../services/reporting/clients.service';
import { AgentService } from './../../../services/agent.service';
import { ThrowStmt } from '@angular/compiler';
import { SelectItem, Message } from 'primeng/primeng';
import { AuthService } from './../../../services/auth.service';
import { StoreService } from './../../../services/store.service';
import { Router } from '@angular/router';
import { CommandeService } from './../../../services/commande.service';
import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { of } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-listcommande',
  templateUrl: './listcommande.component.html',
  styleUrls: ['./listcommande.component.css']
})
export class ListcommandeComponent implements OnInit {
  listZone: SelectItem[] = [];
  titre = 'Suivi commandes';
  commandes: any[] = [];
  msgs: Message[] = [];
  allCommandes: any[] = [];
  role: string;
  state = 'ENCOURS';
  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  dateFin: any = new Date();
  dateDebut: any = new Date();
  typeCommande: any;
  pdg: any;
  listeTypeCommande: SelectItem[] = [
    {
      label: '--Selectionner--', value: ''
    },
    {
      label: 'AIRTIME', value: 'Airtime'
    },
    {
      label: 'MOBILE MONEY', value: 'Mobile Money'
    },
    {
      label: 'PRODUIT', value: 'Produits'
    }];

  listePdg: SelectItem[] = [
    {
      label: 'Selectionner...', value: ''
    },
  ];


  listEtat: SelectItem[] = [
    {
      label: '--Selectionner--', value: ''
    },
    {
      label: 'ENCOURS', value: 'ENCOURS'
    },
    {
      label: 'VALIDE', value: 'VALIDE'
    },
    {
      label: 'REJET', value: 'REJET'
    }];
  size = 5;
  totalElements: number;
  referenceCommande: any;
  zoneLivraison: any;
  etatLivraison: any;
  displaychargement = false;
  constructor(private datePipe: DatePipe, private commandeService: CommandeService, private route: Router, private store: StoreService,
    public authService: AuthService, public agentService: AgentService, private clientsService:  ClientsService, private excelService: ExcelService) { }

  // En attente, encours, valide, rejete, neutre (non reçu)
  async ngOnInit() {
    this.role = this.authService.currentUser.role;
    if (this.role === 'PARTENAIRE') {
      this.getCommandeByLogin(this.authService.currentUser.nomPdg, this.state);
    } else {
      this.getCommandeByRoleAndEtat(this.role, this.state);
    }
    await this.getListZone();
    await this.getListPdg();
  }

  async getListPdg(){
      try {
        if(this.store.isUserPartenaire) {
          this.listePdg.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
          this.pdg = this.store.currentNomPDG;
        } else {
          let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
          for (let el of dataRetourPdg) {
            this.listePdg.push({ label: el.login + " - " + el.msisdn, value: el.login });
          }
        }
      } catch (error) { }
  }

  getTypeCommandeLogo(typeCommande) {
    return ({ 'Airtime': '/assets/dist/img/nafama_logo.svg', 'Produits': '/assets/dist/img/produitc_logo.svg', 'Mobile Money': '/assets/dist/img/orange_money.svg' })[typeCommande];
  }

  ngAfterViewChecked() {
    console.log("! changement de la date du composant !");
  }

  async getListZone() {
    console.log('getListZone: ', this.listZone);
    this.listZone = [
      { label: 'ZONE...', value: null },
      ...(await this.agentService.findAllZone().toPromise() as any).map(element => {
        return {
          label: element.nom, value: element.nom
        };
      })];
    console.log('listZone: ', this.listZone);
  }

  onChangeTypeCommande(event) {
    this.typeCommande = event.value;
    console.log('typeCommande: ', this.typeCommande);
  }

  onChangePdg(event) {
    this.pdg = event.value;
    console.log('typeCommande: ', this.pdg);
  }

  async getAllCommandes() {
    this.displaychargement = true;
    this.state = 'HISTORIQUE';
    this.allCommandes = <any>await this.commandeService.commandes().toPromise();
    this.commandes = this.allCommandes;
    this.displaychargement = false;
  }

  async getCommandeByRoleAndEtat(target: any, state: any) {
    this.displaychargement = true;
    this.state = state;
    try {
      this.allCommandes = <any>await this.commandeService.commandeByRoleAndEtat(target, state).toPromise();
      console.log('currenteUser:', this.authService.currentUser);
      console.log('this.allCommandes: ', this.allCommandes);
      console.log('this.authService.currentUser.role: ', this.authService.currentUser);
      if (this.authService.currentUser.role === 'MAGASIN_AGENT') {
        //this.allCommandes.forEach(e => { console.log('commande: ', e) });
        this.allCommandes = this.allCommandes.filter(e => e.zone === this.authService.currentUser.zone);
        console.log('End***********')

      }
      this.commandes = this.allCommandes;
      console.log('after***********', this.commandes)
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }


  localeDateString(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === 'string') {
      return val;
    } else {
      //return  (new Date(Date.parse(val))).toLocaleDateString();
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }

  async searchNew() {
    this.displaychargement = true;

    /*
    if (this.role === 'PARTENAIRE') {
      await this.getCommandeByLogin(this.authService.currentUser.nomPdg, this.state);
    } else {
      await this.getAllCommandes();
      //this.getCommandeByRoleAndEtat(this.role, this.state);
    }
    */

    const criteria = {
      typeCommande: this.typeCommande,
      dateDebut: this.localeDateString(this.dateDebut),
      dateFin: this.localeDateString(this.dateFin),
      pdg: this.pdg,
      statut: this.etatLivraison,
      etat : this.state,
      //role: this.role,
      //critere : this.displayAllCommande?"OK":"ENCOURS",
      referenceCommande: this.referenceCommande,
      zone: this.zoneLivraison,
    };
    console.log('criteria: ', criteria);
    try {
      this.commandes = <any>await this.commandeService.getCommandeByCriteria(criteria).toPromise();
    } catch (error) {
      console.log("error",error);
      this.commandes = [];
    }
    console.log('commandes: ', this.commandes);
    this.displaychargement = false;
  }

  async search() {
    this.displaychargement = true;
    const criteria = {
      typeCommande: this.typeCommande,
      dateDebut: this.dateDebut,
      dateFin: this.dateFin,
      pdg: this.pdg,
      etat: this.state,
      referenceCommande: this.referenceCommande,
      zone: this.zoneLivraison,
      etatLivraison: this.etatLivraison
    };
    console.log('criteria: ', criteria);
    // this.commandes = <any>await this.commandeService.getCommandeByCriteria(criteria).toPromise();
    this.commandes = this.allCommandes.filter(e => {
      console.log('criteres<<<<<<<<<<<<<<<<<<< ', criteria);
      let match = true;
      if (criteria.typeCommande) {
        match = match && e.typeCommande === criteria.typeCommande;
      }
      if (criteria.dateDebut) {
        match = match && e.dateCommande >= criteria.dateDebut;
      }

      if (criteria.dateFin) {
        match = match && e.dateCommande <= criteria.dateFin;
      }
      if (criteria.pdg) {
        match = match && e.login === criteria.pdg;
      }
      if (criteria.referenceCommande) {
        match = match && e.referenceCommande === criteria.referenceCommande;
      }
      if (criteria.zone) {
        match = match && e.zone === criteria.zone;
      }
      if (criteria.etatLivraison) {
        match = match && e.etatLivraison === criteria.etatLivraison;
      }

      console.log('match <<<<<<<<<<<< ', match);
      return match;
    });
    this.displaychargement = false;
  }

  async exporter() {
    if(this.commandes === null || this.commandes === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if(this.commandes.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.commandes.map(entry => ({
        "TYPE_COMMANDE": entry.typeCommande,
        "PARTENAIRE": entry.login,
        "REFERENCE COMMANDE": entry.referenceCommande,
        "REFERENCE ORACLE": entry.referenceOracle,
        "MONTANT": entry.montant,
        "DEVISE": entry.devise,
        "AGENT": entry.agent,
        "ETAT":entry.etatLivraison,
        "ETAPE":entry.etat,
        "FACTURE":entry.facture,
        "DATE_COMMANDE": new Date(entry.dateCommande).toLocaleString()
      }))
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.commandes.length + ' Ligne(s) trouvée(s)' });
  }

  async getCommandeByLogin(login: any, state?: any) {
    this.displaychargement = true;
    this.state = state;
    try {
      this.allCommandes = <any>await this.commandeService.commandeByLoginAndEtat(login, state).toPromise();
      this.commandes = this.allCommandes;
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }

  async getOracle(reference: any) {
    this.displaychargement = true;
    try {
      this.commandes = []; //<any>await this.commandeService.getOracleData(reference).toPromise();
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }

  goToDetailCommande(commande: any) {
    this.store.tmp.commande = commande;
    /*
    if (this.state === 'ENCOURS' && this.authService.currentUser.role !== 'PARTENAIRE') {
      this.route.navigateByUrl('/root/validation-commande?id=' + commande.id);
    } else {
      this.route.navigateByUrl('/root/detail-commande?id=' + commande.id);
    }
    */
    this.route.navigateByUrl('/root/detail-commande?id=' + commande.id);
  }

  getCommandes(role: any, state: any) {
    this.state = state;
    this.getCommandeByRoleAndEtat(role, state);
  }
}
